import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getNotifier } from '../api/index.js'
import { queryKeys } from '../queries/index.js'
import { notificationService } from '../services/index.js'

/**
 * Mark every unread notification as read in one call.
 *
 * Invalidating `queryKeys.notifications` covers the whole family by prefix —
 * the bell's list, the Notifications page's infinite list, and the unread
 * count that drives the badge.
 */
export function useMarkAllNotificationsRead() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => notificationService.markAllNotificationsAsRead(),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.notifications })
    },
    onError: (error) => {
      console.error('Error marking all notifications as read:', error)
      getNotifier().error('Could not mark notifications as read. Please try again.')
    },
  })
}
